// src/api.ts
import { useAuth } from "./auth/AuthProvider";

// Hook for React components
export function useApi() {
  const { idToken } = useAuth();

  const apiFetch = async (url: string, options: RequestInit = {}) => {
    const headers = new Headers(options.headers || {});
    if (idToken) {
      headers.set("Authorization", `Bearer ${idToken}`);
    }

    return fetch(url, {
      ...options,
      headers,
    });
  };

  return { apiFetch };
}

// Standalone function (for non-React code)
export async function apiFetch(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  const idToken = sessionStorage.getItem("idToken");
  const headers = new Headers(options.headers || {});

  if (idToken) {
    headers.set("Authorization", `Bearer ${idToken}`);
  }

  if (options.body && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  return fetch(url, {
    ...options,
    headers,
  });
}
